import { Injectable } from '@angular/core';

import { ParagraphHeroData } from '@generated/content';
import { CmsComponentConfig, HeroSlider } from '@interfaces/config';
import { CmsComponentNodeData, CmsFixes, TMediaNodeType, TImageConfig } from '@interfaces/index';
import { YoutubeVideo } from '@models/classes';
import {   ParagraphNewsTickerData,ParagraphNewsTickerItemData} from '@generated/content'
import { BaseComponentResolver } from '../../../_base/base-component-resolver/base-component-resolver';
import { DocumentResolver } from '../../auxiliary/document-resolver';
import { TextMediaBox } from '@interfaces/config';
import { ButtonTypeEnum, CmsComponentTypeEnum, CmsMediaTypeEnum, MediaTypesEnum } from '@models/enums';
import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';
import { StringHelper } from '@lib/utils/helpers/string-helper/string-helper';
import { LinkObject } from '@models/interfaces';
import {
  FileFileData,
  MediaAudioData,
  MediaImageData,
  MediaRemoteVideoData,
  MediaVideoData,
  ParagraphTextMediaBoxData,
} from '@generated/content';
import { DocumentReference } from '@interfaces/documents';

@Injectable({ providedIn: 'root' })
export class HeroSliderComponentResolver extends BaseComponentResolver {
  static override instance: HeroSliderComponentResolver;
  private readonly componentType = ParagraphHeroData.TypeEnum.ParagraphHero;

  static getInstance(): HeroSliderComponentResolver {
    return (HeroSliderComponentResolver.instance ||= new HeroSliderComponentResolver());
  }

  public override resolveComponentConfig(
    node: CmsComponentNodeData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<HeroSlider.ComponentConfig> | null {
    this.nodePageData = nodePageData;

    
    let isNewsTicker = false;
  
    var newTickerModule =  nodePageData.filter(function(event){
      return event.type ==  ParagraphNewsTickerData.TypeEnum.ParagraphNewsTicker;
    });
    let field_news_ticker_position = 'bottom';
   if(newTickerModule && newTickerModule.length>0){
    field_news_ticker_position = this.getNewsTickerPosition(newTickerModule[0])
    isNewsTicker = true;
   }
  
    const heroNodes = this.getNodes<ParagraphHeroData>(this.componentType);

    if (!heroNodes.length) {
      return null;
    }

    const slides: HeroSlider.SlideConfig[] = heroNodes.map(this.buildSlide.bind(this));
    const nodeId = this.getNodeId(node);
  
    return { componentType: CmsComponentTypeEnum.HERO_SLIDER, config: { field_news_ticker_position, nodeId, slides,isNewsTicker,newsItems:this.buildNews() } };
  }

 private getNewsTickerPosition(node:any):string{

  if(node.attributes?.field_news_ticker_position){
    return node.attributes.field_news_ticker_position;
  }

  return null;
 }
  
  private buildNews():HeroSlider.NewsConfig[]{

    let newsItemNodes = this.nodePageData.filter(function(news){
      return news.type ==  ParagraphNewsTickerItemData.TypeEnum.ParagraphNewsTickerItem
        
       
    });

    let news:HeroSlider.NewsConfig[] = [];
    newsItemNodes.forEach((newsItemNode) => {
 
      news.push({uri:HeroSliderComponentResolver.extractLink(newsItemNode),newsTitle:newsItemNode.attributes['field_news_ticker_text']['value']})
     
    });

    return news;
    

  }

    private static extractLink(node: any): LinkObject | null {
      if (!node?.attributes?.field_link_sh) {
        return null;
      }

   
   
      const { title, uri,url } = node?.attributes?.field_link_sh;


      const href = url ||  uri;
    
      const external = href.startsWith('http');
  
      if (title && href) {
        return { label: this.hyphenate(title), href, external };
      }
  
      return null;
    }
  private buildSlide(node: ParagraphHeroData): HeroSlider.SlideConfig {
    const htmlHeadline = this.hyphenate((node.attributes?.field_headline_hero as CmsFixes.CmsFreetextObject)?.processed);
    const textHeadline = this.hyphenate(StringHelper.stripTags(htmlHeadline));
    const subHeadline = this.hyphenate(node.attributes.field_sub_headline_hero);

    const imageConfig = this.getImageConfig(node);
    const media = this.getMediaConfig(node);

    const reference = this.getReference(node);
   const link  = this.getLink(node);
  
    const gradientOverlay = node.attributes.field_overlay_color_hero?.color || null;
 
    return { media,subHeadline, headline: textHeadline, gradientOverlay, reference, imageConfig,link};
  }

  private getLink(node: ParagraphHeroData): any {
    if (!node?.attributes?.field_link_hero?.url) {
      return null;
    }
    const { url,title } = node.attributes.field_link_hero;
    return {href:url,label:title};
  }
  private getMediaConfig(
    node: ParagraphHeroData
  ):
   
    | TextMediaBox.MediaYoutubeVideoConfig
    | TextMediaBox.MediaVideoConfig
    | TextMediaBox.MediaAudioConfig {
    if (!node?.relationships?.field_heroimage?.data) {
      return null;
    }

    const { type, id } = node.relationships.field_heroimage.data;

    switch (type) {
      case CmsMediaTypeEnum.Video:
        return this.getMediaVideoConfig(id);
     

   

 

      default:
        return null;
    }
  }

  
  private getMediaAudioConfig(id: string): TextMediaBox.MediaAudioConfig {
    const mediaAudioNode = this.getNode<MediaAudioData>(id, CmsMediaTypeEnum.Audio);
    const fileNodeId = mediaAudioNode?.relationships?.field_media_audio_file?.data?.id;

    if (!fileNodeId) {
      return null;
    }

    const fileNode = this.getNode<FileFileData>(
      mediaAudioNode?.relationships?.field_media_audio_file?.data?.id,
      FileFileData.TypeEnum.FileFile
    );

    return {
      type: MediaTypesEnum.AUDIO,
      url: fileNode?.attributes?.uri?.url ?? null,
      fileNodeId,
      metas: {
        title: mediaAudioNode.attributes.field_title ?? 'Podcast',
        description: mediaAudioNode.attributes.field_description ?? null,
      },
    };
  }
  private getMediaVideoConfig(id: string): TextMediaBox.MediaVideoConfig {
    const mediaVideoNode = this.getNode<MediaVideoData>(id, CmsMediaTypeEnum.Video);

    const thumbnailNode = this.getNode<FileFileData>(
      mediaVideoNode?.relationships?.thumbnail?.data?.id,
      FileFileData.TypeEnum.FileFile
    );

    let thumbnail: string = null;

    if (thumbnailNode?.attributes?.image_style_uri) {
      thumbnail =
        thumbnailNode.attributes.image_style_uri['webp'] || thumbnailNode.attributes.image_style_uri['thumbnail'] || null;
    }

    const fileNode = this.getNode<FileFileData>(
      mediaVideoNode?.relationships?.field_media_video_file?.data?.id,
      FileFileData.TypeEnum.FileFile
    );

    if (!fileNode?.attributes?.uri?.url) {
      return null;
    }

    return {
      type: MediaTypesEnum.VIDEO,
      url: fileNode.attributes.uri.url,
      caption: null,
      metas: null,
      thumbnail,
    };
  }
  private getImageConfig(node: ParagraphHeroData): TImageConfig {

    if (!node?.relationships?.field_heroimage?.data?.id) {
      return null;
    }
    if (node?.relationships?.field_heroimage?.data?.type === 'media--video') {
      return null;
    }
    const { id, type } = node.relationships.field_heroimage.data;
    return  this.getMediaDataUrls(id, type as TMediaNodeType, null, true) || { dataUrls: null, metas: null };

     
  }

  private getReference(node: ParagraphHeroData): DocumentReference {
    if (!node.relationships.field_references?.data?.id) {
      return null;
    }

    return DocumentResolver.getDocumentReference(node.relationships.field_references.data.id, this.nodePageData);
  }
}
